module.exports = new __parcel__URL__("dark.f0a859af.svg").toString();